import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const AddEditMarketplace = () => {
  const [formData, setFormData] = useState({
    name: '',
    icon: '', // this will now hold the uploaded S3 URL
  });
  const [isEditing, setIsEditing] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (id) {
      setIsEditing(true);
      const fetchMarketplace = async () => {
        try {
          const response = await axios.get(`${API_URL}/marketplace/getMarketplaceById/${id}`);
          setFormData(response.data);
        } catch (error) {
          console.error('Error fetching marketplace:', error);
        }
      };

      fetchMarketplace();
    }
  }, [id]);

  const handleImageUpload = async (file) => {
    if (!file) {
      toast.error("No file selected!");
      return null;
    }

    const formImage = new FormData();
    formImage.append("image", file);

    try {
      const response = await fetch(`${API_URL}/image/upload`, {
        method: "POST",
        body: formImage,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Upload failed");
      }

      toast.success("Icon uploaded successfully!");
      return data.imageUrl;
    } catch (error) {
      console.error("Upload Error:", error);
      toast.error("Error uploading icon: " + error.message);
      return null;
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = await handleImageUpload(file);
      if (imageUrl) {
        setFormData({ ...formData, icon: imageUrl });
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEditing) {
        await axios.put(`${API_URL}/marketplace/updateMarketplace/${id}`, formData);
        toast.success('Marketplace updated successfully!');
      } else {
        await axios.post(`${API_URL}/marketplace/createMarketplace`, formData);
        toast.success('Marketplace created successfully!');
      }
      navigate('/marketplace');
    } catch (error) {
      console.error('Error saving marketplace:', error);
      toast.error('Failed to save marketplace.');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <div className="container mx-auto mt-10 p-5 max-w-lg shadow-lg bg-white rounded-lg">
      <h1 className="text-2xl font-semibold mb-5 text-center">
        {isEditing ? 'Edit Marketplace' : 'Add Marketplace'}
      </h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-700">
            Marketplace Name
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required
            className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:ring-0 focus:border-black sm:text-sm p-2"
          />
        </div>

        <div>
          <label htmlFor="icon" className="block text-sm font-medium text-gray-700">
            Icon (Upload Image)
          </label>
          <input
            type="file"
            id="icon"
            name="icon"
            accept="image/*"
            onChange={handleFileChange}
            className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:ring-0 focus:border-black sm:text-sm p-2"
          />
          {formData.icon && (
            <img
              src={formData.icon}
              alt="Icon Preview"
              className="w-16 h-16 mt-2 object-cover border"
            />
          )}
        </div>

        <div className="flex gap-2">
          <button
            type="submit"
            className={`px-5 py-2 rounded-md text-white font-medium bg-[#1c2434]`}
          >
            {isEditing ? 'Update' : 'Add'}
          </button>
          <button
            type="button"
            onClick={() => navigate('/marketplace')}
            className="px-5 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-md font-medium"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddEditMarketplace;
